import Vue from "vue";
import VeeValidate from "vee-validate";
import(
  /* webpackChunkName: "chunk-aurora" */ "@/components/aurora/webcomponents-loader"
);
import "./utils/filters";
import App from "./App.vue";
import router from "./router";

import "./sass/base.scss";
import store from "./store";
import i18n from "./i18n";

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/cm-\w*/];

// Polyfill for using string includes method
if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    "use strict";
    if (search instanceof RegExp) {
      throw TypeError("first argument must not be a RegExp");
    }
    if (start === undefined) {
      start = 0;
    }
    return this.indexOf(search, start) !== -1;
  };
}
// Polyfill for using string endsWith method
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (pattern) {
    var d = this.length - pattern.length;
    return d >= 0 && this.lastIndexOf(pattern) === d;
  };
}

Vue.use(VeeValidate, {
  i18nRootKey: "validations", // customize the root path for validation messages.
  i18n,
});
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
